/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Manage_Permissions_DescriptionInputs */

const en_admin_roles_manage_permissions_description = /** @type {(inputs: Admin_Roles_Manage_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select permissions for this role`)
};

const zh_admin_roles_manage_permissions_description = /** @type {(inputs: Admin_Roles_Manage_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择此角色的权限`)
};

/**
* | output |
* | --- |
* | "Select permissions for this role" |
*
* @param {Admin_Roles_Manage_Permissions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_manage_permissions_description = /** @type {((inputs?: Admin_Roles_Manage_Permissions_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Manage_Permissions_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_manage_permissions_description(inputs)
	return zh_admin_roles_manage_permissions_description(inputs)
});
export { admin_roles_manage_permissions_description as "admin.roles.manage_permissions_description" }